import { API_URL, THEME_COLOR,numberWithCommas, CMS_URL } from '../../constant';
import React, {useEffect, useState} from 'react';
import { useLocalStorage } from "../../useLocalStorage";
import { Typography } from '@mui/material';
import RecommendIcon from '@mui/icons-material/Recommend';
import Swal from 'sweetalert2';
let MiniCart = (props)=>{
    
    const [token, setToken] = useLocalStorage("token", "");
    const [sumorder, setSumOrder] = useState(0);
    const [items, setItems] = useState([]);
    const [prices, setPrices] = useState([]);

    let prevwh = 0;
    let prevshipmethod = "";
    let prevshipdetail = 0;
    
    function submitHandler(){
        // let titems = items.filter((value, index)=>{
        //     return value.IsChecked;
        // })
        // if(titems.length == 0){
        //     toast.error('No item selected!');
        // }else{
        //     history.push('/checkout', { items: titems })
        // }
    }

    let Cardcontainer = (props) => {
        return (
            <div className="cart-card" key={`wh-${props.uniquekey}`}>
                <div className="cart-card-container">
                    <div className="cart-item-header">
                        <div className="cart-warehouse-name">
                            {props.warehousename}
                        </div>
                        <div className="cart-shipping-method">
                            {props.shippingmethod}
                        </div>
                    </div>
                    <hr />
                    {
                        props.items.map((value, index)=>{
                            let imgurl = `${CMS_URL}/images/no-image-found.jpg`;
                            if(value.ImageName){
                                imgurl = `${CMS_URL}/images/upload/product/${value.Code}/${value.ImageName}`;
                            }
                            return (
                                <div className="cart-item-detail" key={`${value.ID}-${index}`}>
                                    <div className="cart-item-image">
                                        <img src={imgurl}/>
                                    </div>
                                    <div className="cart-item-summary">
                                        <div className="cart-item-name">
                                            <span>{(value.PromoID !== 0) ? `[PROMO]` : ``} {value.ItemName}</span>
                                        </div>
                                        <div className="detail-promo-color">
                                            <span>Color: {value.ItemColor}</span>
                                        </div>
                                        <div className="detail-promo-size">
                                            <span>Size: {value.ItemSize}</span>
                                        </div>
                                        {
                                            (value.Stock <= 0)?
                                            (
                                                <div>
                                                    <span style={{"fontSize":"8pt", "color": "#FF1111"}}>Out of Stock</span>
                                                </div>       
                                            ):
                                            (
                                                <></>
                                            )
                                        }
                                        <div className="cart-item-price">
                                            Rp {numberWithCommas(value.ItemPrice)}
                                        </div>
                                        <div className="cart-qty-container">
                                            <div className="cart-qty-input">
                                                <div className="cart-button" onClick={()=> decrementQty(value.ID, value.ItemUnitID)}>
                                                    -
                                                </div>
                                                <div style={{width: "17%"}} >
                                                    <input type="text" data-itemid={value.ID} data-promoid={value.PromoID} defaultValue={value.ItemQty}  onChange={qtyChange} onKeyPress={qtyKeyPress} disabled={(value.PromoID !== 0) ? "disabled" : ""}  />
                                                </div>
                                                <div className="cart-button" onClick={()=> incrementQty(value.ID, value.ItemUnitID)}>
                                                    +
                                                </div>
                                                <div>
                                                    <i className="material-icons left delete-icon" onClick={()=>deleteItem(value.ID, value.ItemName, value.PromoID, value.PromoName)}>delete</i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }

    async function decrementQty(ID, ItemUnitID){
        let index = 0;
        let titems = [...items];
        let item = titems.filter((value,idx)=> {
            if(value.ID == ID && value.ItemUnitID == ItemUnitID)
                index = idx;
            return value.ID == ID && value.ItemUnitID == ItemUnitID
        })[0];
        if(item.PromoID === 0){
            item.ItemQty -= 1;
            if(item.ItemQty < 1){
                item.ItemQty = 1;
            }
            let itemprice = prices.filter((value,index)=>{
                return value.ItemUnitID == item.ItemUnitID
            })
            itemprice.forEach((value, index)=>{
                if(item.ItemQty >= value.Qty)
                    item.ItemPrice = value.Price
            })
            titems[index] = item;
            setItems(titems);
        }
        // recalculate();
    }

    function incrementQty(ID , ItemUnitID){
        let index = 0;
        let titems = [...items];
        let item = titems.filter((value,idx)=> {
            if(value.ID == ID && value.ItemUnitID == ItemUnitID)
                index = idx;
            return value.ID == ID && value.ItemUnitID == ItemUnitID
        })[0];
        if(item.PromoID === 0){
            item.ItemQty++;
            if(item.ItemQty > item.Stock){
                item.ItemQty = item.Stock
            }
            let itemprice = prices.filter((value,index)=>{
                return value.ItemUnitID == item.ItemUnitID
            })
            itemprice.forEach((value, index)=>{
                if(item.ItemQty >= value.Qty)
                    item.ItemPrice = value.Price
            })
            titems[index] = item;
            setItems(titems);
            // recalculate();
        }
        
    }


    function qtyKeyPress(event){
        if(! (event.charCode >= 46 && event.charCode <= 57)){
            event.preventDefault();
        }
    }
    
    function qtyChange(e){
        let index = 0;
        let titems = [...items];
        // let item = items[index];
        if(e.target.dataset.promoid == 0){
            let item = titems.filter((value,idx)=> {
                if(value.ID == e.target.dataset.itemid)
                    index = idx;
                return value.ID == e.target.dataset.itemid
            })[0];
            item.ItemQty = (!e.target.value || e.target.value=="" || e.target.value == isNaN)? 1: parseInt(e.target.value)
            if(item.ItemQty < 1){
                item.ItemQty = 1;
            }
            if(item.ItemQty > item.Stock){
                item.ItemQty = item.Stock
            }
            let itemprice = prices.filter((value,index)=>{
                return value.ItemUnitID == item.ItemUnitID
            })
            itemprice.forEach((value, index)=>{
                if(item.ItemQty >= value.Qty)
                    item.ItemPrice = value.Price
            })
            titems[index] = item;
            setItems(titems);
            // recalculate();
        }
    }

    function deleteItem(ID, Name, PromoID, PromoName){
        Swal.fire({
            title: "Are you sure?",
            text: `You won't be able to recovery ${(PromoID === 0)? Name: PromoName}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#ff3d00',
            cancelButtonColor: '#d33',
            confirmButtonText: `Yes, remove it!`
        }).then( async (result)=>{
            if(result.isConfirmed){
                let titems = [...items];
                titems = titems.filter((value,index)=> {
                    return value.ID !== ID
                });
                setItems(titems)
                props.setCart(titems)
            }
        })
    }

    useEffect(()=>{
        console.log(props.items)
        setItems(props.items)
    },[]);
    return (
        <div className=''>
            <div style={{width:"100%", padding: "10px 0", marginBottom:"30px"}}>
                {
                    items.map((value, index)=>{
                        if(prevwh != value.WarehouseDetail.WarehouseID || prevshipmethod != value.ShippingMethod || prevshipdetail != value.ShippingDetail.ShippingDetailID){
                            prevwh = value.WarehouseDetail.WarehouseID;
                            prevshipmethod = value.ShippingMethod;
                            prevshipdetail = value.ShippingDetail.ShippingDetailID;
                            return (
                                <Cardcontainer
                                    items={items.filter((value,index)=> value.WarehouseDetail.WarehouseID == prevwh && value.ShippingMethod == prevshipmethod && value.ShippingDetail.ShippingDetailID == prevshipdetail )}
                                    key={index}
                                    uniquekey={index}
                                    warehousename={value.WarehouseDetail.WarehouseName}
                                    shippingmethod= {value.ShippingMethod}
                                    setCart = {props.setCart}
                                />
                            )
                        }
                    })
                }
            </div>
        </div>
    );
}

export default MiniCart;